<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true">
    <button
      toggle="visible"
      cHeaderToggler
      [cSidebarToggle]="sidebarId"
      class="ps-1"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <label
      class="text-center"
      [style]="{'font-weight': 'bold',
    'font-size': '1.5rem', }"
      >{{ livedatetime }}</label
    >
    <!-- <c-header-nav class="d-none d-lg-flex me-auto">
      <c-nav-item>
        <a cNavLink routerLink="/dashboard" routerLinkActive="active">
          Dashboard
        </a>
      </c-nav-item>
      <c-nav-item>
        <a cNavLink routerLink="/users" routerLinkActive="active">Users</a>
      </c-nav-item>
      <c-nav-item>
        <a cNavLink routerLink="/settings" routerLinkActive="active">
          Settings
        </a>
      </c-nav-item>
    </c-header-nav> -->

    <!-- <c-header-nav class="d-none d-lg-flex">
      <c-nav-item>
        <a routerLink="./" cNavLink>
          <svg cIcon name="cilBell" size="lg"></svg>
        </a>
      </c-nav-item>
      <c-nav-item>
        <a routerLink="./" cNavLink>
          <svg cIcon name="cilList" size="lg"></svg>
        </a>
      </c-nav-item>
      <c-nav-item>
        <a routerLink="./" cNavLink>
          <svg cIcon name="cilEnvelopeOpen" size="lg"></svg>
        </a>
      </c-nav-item>
    </c-header-nav> -->

    <c-header-nav class="ms-3">
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>
  </c-container>
  <c-header-divider></c-header-divider>
  <c-container [fluid]="true">
    <c-breadcrumb-router class="ms-2"></c-breadcrumb-router>
  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <!-- <dropdown alignment="end" variant="nav-item"> -->
  <!-- <button cButton color="" cDropdownToggle class="py-0">
    <c-avatar
      cTextColor="primary"
      shape="rounded-1"
      size="md"
      src="./assets/img/avatars/8.jpg"
      status="success"
    >
    </c-avatar>
  </button> -->
  <!-- <ul cDropdownMenu class="pt-0 pr-5 w-auto">
    <li> -->

  <!-- <svg cIcon class="me-2" name="cilLockLocked"></svg> -->

  <p-button
    (click)="Logout()"
    class="mx-1"
    icon="pi pi-sign-out"
    styleClass="p-button-rounded p-button-info"
  ></p-button>
  <!-- Logout -->

  <!-- </li>
  </ul> -->
  <!-- </c-dropdown> -->
</ng-template>
